import type { ReactNode } from 'react'

interface EmptyStateProps {
  title: string
  description?: string
  icon?: ReactNode
  actions?: ReactNode
  compact?: boolean
}

export function EmptyState({ title, description, icon, actions, compact = false }: EmptyStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: compact ? 10 : 16,
        padding: compact ? 32 : 64,
        color: 'var(--text)',
        textAlign: 'center',
      }}
    >
      {icon ? (
        <div style={{ fontSize: 32, opacity: 0.5, lineHeight: 1 }}>{icon}</div>
      ) : null}
      <p style={{ margin: 0, fontSize: compact ? 15 : 18, opacity: 0.7 }}>{title}</p>
      {description ? (
        <p style={{ margin: 0, fontSize: 13, opacity: 0.45, maxWidth: 360 }}>{description}</p>
      ) : null}
      {actions ? (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center', marginTop: 4 }}>
          {actions}
        </div>
      ) : null}
    </div>
  )
}
